import { render, staticRenderFns } from "./OrderPayment.vue?vue&type=template&id=52b51c3b&scoped=true&"
import script from "./OrderPayment.vue?vue&type=script&lang=js&"
export * from "./OrderPayment.vue?vue&type=script&lang=js&"
import style0 from "./OrderPayment.vue?vue&type=style&index=0&id=52b51c3b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b51c3b",
  null
  
)

export default component.exports